module.exports = __webpack_public_path__ + "static/media/smileRating3.3a7b94d4.svg";